/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
// @ts-check
/** @jsx jsx */
import { Box, Container } from '@bottlebooks/gatsby-theme-base';
import { jsx } from 'theme-ui';
import Layout from '@bottlebooks/gatsby-theme-event/src/components/Layout';
import PersonalHeader from './PersonalHeader';
import PersonalMenu from './PersonalMenu';

export default function PersonalPageLayout({ locale, children, ...rest }) {
  return (
    <Layout locale={locale}>
      <PersonalHeader>
        <PersonalMenu />
      </PersonalHeader>
      <Box sx={{ backgroundColor: 'light' }} {...rest}>
        {children}
      </Box>
    </Layout>
  );
}

export function ListContainer({ children, ...rest }) {
  return (
    <Container sx={{ paddingX: [0, 'gutter'], paddingBottom: 5 }} {...rest}>
      {children}
    </Container>
  );
}
